import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navvbar } from "../../components";
import { Commons } from "../../utilities";
import { GoHome } from "react-icons/go";
import {
    PiCalendar,
    PiStethoscopeLight,
    PiUserCircle,
    PiClockUserLight,
    PiSealQuestionLight,
    PiScrollLight,
    PiBell
} from "react-icons/pi";
import { RiMessage2Line } from "react-icons/ri";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import { LuMessagesSquare, LuEuro, LuLogOut } from "react-icons/lu";
import { SlSettings } from "react-icons/sl";
import { FaCaretRight, FaCaretDown, FaCaretUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const LeftSides = ({ loginData }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const handleToggle = (isOpen) => {
        setIsDropdownOpen(isOpen);
    };
    const handaleProfileNavigate = () => {
        if (loginData?.userType === Commons.userType.doctor) {
            navigate("/doctor/my-profile/personal-information");
        } else if (loginData?.userType === Commons.userType.patient) {
            navigate("/patient/my-profile/personal-information");
        } else if (loginData?.userType === Commons.userType.admin) {
            navigate("");
        }
    };

    const handleLogout = (access) => {
        localStorage.removeItem(access);
        if (access === "doctor_access") {
            window.location.href = "/doctor/login";
        } else if (access === "patient_access") {
            window.location.href = "/patient/login";
        } else if (access === "admin_access") {
            window.location.href = "/admin/login";
        }
    };

    const docSections = [
        {
            items: [
                {
                    type: "link",
                    label: (
                        <span>
                            <GoHome className="vs-icons" /> {t("dashboard")}
                        </span>
                    ),
                    path: "/doctor/dashboard",
                },
            ],
        },
        {
            title: `${t("appointments.appointments")} & ${t("Patient.patients")}`,
            items: [
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <PiCalendar className="vs-icons" />{" "}
                                {t("appointments.appointments")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Requests")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/appointment-request/my-appointments",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Upcoming")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/appointment-upcoming/my-appointments",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Completed")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/appointment-completed/my-appointments",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Cancelled")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/appointment-cancelled/my-appointments",
                        },
                    ],
                },
                {
                    type: "link",
                    label: (
                        <>
                            <PiStethoscopeLight className="vs-icons" /> {t("doctor.Doctors")}
                        </>
                    ),
                    path: "/doctor/my-doctors",
                },
                {
                    type: "link",
                    label: (
                        <>
                            <PiUserCircle className="vs-icons" /> {t("Patient.patients")}
                        </>
                    ),
                    path: "/doctor/my-patients",
                },
            ],
        },
        {
            title: `${t("Communication")} & ${t("Schedule")}`,
            items: [
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <PiClockUserLight className="vs-icons" /> {t("Schedule")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("My_Schedule")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/my-schedule/default-working-time",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("Clinic_Schedule")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/clinic-schedule",
                        },
                    ],
                },
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <RiMessage2Line className="vs-icons" /> {t("Chats")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.requested.requested")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/chat-requested",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.onGoing.onGoing")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/chat-ongoing",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.completed.completed")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/chat-completed",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.Cancelled.cancelled")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/chat-cancelled",
                        },
                    ],
                },

                {
                    type: "link",
                    label: (
                        <>
                            <HiOutlinePhoneMissedCall className="vs-icons" />{" "}
                            {t("Emergency_Calls")}
                        </>
                    ),
                    path: "/doctor/emergency-calls",
                },
                {
                    type: "link",
                    label: (
                        <>
                            <LuMessagesSquare className="vs-icons" /> {t("Mass_Messages")}
                        </>
                    ),
                    path: "/doctor/mass-messages/compose-message",
                },
            ],
        },
        {
            title: `${t("Finance")} & ${t("Invoices")}`,
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <LuEuro className="vs-icons" /> {t("Finances")}
                        </>
                    ),
                    path: "/doctor/my-finances",
                },
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <PiScrollLight className="vs-icons" /> {t("Invoices")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("invoice_list")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/list-of-invoices",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("invoice_setting")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/invoices-setting",
                        },
                    ],
                },
            ],
        },
        {
            title: `${t("Settings")}`,
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <PiSealQuestionLight className="vs-icons" />
                            {t("FAQs")}
                        </>
                    ),
                    path: "/doctor/faq",
                },
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <SlSettings className="vs-icons" /> {t("Settings")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("Profile")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/my-profile/personal-information",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("Fees")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/doctor/my-fees",
                        },
                    ],
                },
                {
                    label: (
                        <>
                            <LuLogOut className="vs-icons" /> {t("Log_Out")}
                        </>
                    ),
                    onClick: () => handleLogout("doctor_access"),
                },
            ],
        },
    ];
    const patSections = [
        {
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <GoHome className="vs-icons" />{t("dashboard")}
                        </>
                    ),
                    path: "/patient/dashboard",
                },
            ],
        },
        {
            title: t("appointments.appointments"),
            items: [
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <PiCalendar className="vs-icons" />{" "}
                                {t("appointments.appointments")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Requests")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/appointment-request",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Upcoming")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/appointment-upcoming",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Completed")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/appointment-completed",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Cancelled")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/appointment-cancelled",
                        },
                    ],
                },
            ],
        },
        {
            title: `${t("Communication")} & ${t("Schedule")}`,
            items: [
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <RiMessage2Line className="vs-icons" /> {t("Chats")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.requested.requested")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/chat-requested",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.onGoing.onGoing")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/chat-ongoing",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.completed.completed")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/chat-completed",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("chatPage.Cancelled.cancelled")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/patient/chat-cancelled",
                        },
                    ],
                },
                {
                    type: "link",
                    label: (
                        <>
                            <HiOutlinePhoneMissedCall className="vs-icons" />{" "}
                            {t("Emergency_Calls")}
                        </>
                    ),
                    path: "/patient/emergency-calls",
                },
            ],
        },
        {
            title: `${t("Finance")} & ${t("Invoices")}`,
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <LuEuro className="vs-icons" /> {t("Finances")}
                        </>
                    ),
                    path: "/patient/my-finances",
                },
                {
                    type: "link",
                    label: (
                        <>
                            <PiScrollLight className="vs-icons" /> {t("Invoices")}
                        </>
                    ),
                    path: "/patient/invoice",
                },
            ],
        },
        {
            title: `${t("Settings")}`,
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <PiSealQuestionLight className="vs-icons" />
                            {t("Profile")}
                        </>
                    ),
                    path: "/patient/my-profile",
                },
                {
                    type: "link",
                    label: (
                        <>
                            <PiBell className="vs-icons" />
                            {t("notification")}
                        </>
                    ),
                    path: "/patient/notifications",
                },
                {
                    label: (
                        <>
                            <LuLogOut className="vs-icons" /> {t("Log_Out")}
                        </>
                    ),
                    onClick: () => handleLogout("patient_access"),
                },
            ],
        },
    ];
    const adminSections = [
        {
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <GoHome className="vs-icons" /> Admin {t("dashboard")}
                        </>
                    ),
                    path: "/admin/dashboard",
                },
            ],
        },
        {
            title: `${t("appointments.appointments")} & ${t("Patient.patients")}`,
            items: [
                {
                    type: "dropdown",
                    title: (
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                                <PiCalendar className="vs-icons" />{" "}
                                {t("appointments.appointments")}
                            </div>
                            {isDropdownOpen ? (
                                <FaCaretUp className="dd-aricons1" />
                            ) : (
                                <FaCaretDown className="dd-aricons1" />
                            )}
                        </div>
                    ),
                    options: [
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Requests")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/admin/appointment-request",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Upcoming")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/admin/appointment-upcoming",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Completed")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/admin/appointment-completed",
                        },
                        {
                            label: (
                                <>
                                    <span>{t("appointments.Cancelled")}</span>
                                    <span>{<FaCaretRight className="dd-aricons" />}</span>
                                </>
                            ),
                            path: "/admin/appointment-cancelled",
                        },
                    ],
                },
                {
                    type: "link",
                    label: (
                        <>
                            <PiStethoscopeLight className="vs-icons" /> {t("doctor.Doctors")}
                        </>
                    ),
                    path: "/admin/doctors",
                },
                {
                    type: "link",
                    label: (
                        <>
                            <PiUserCircle className="vs-icons" /> {t("Patient.patients")}
                        </>
                    ),
                    path: "/admin/patients",
                },
            ],
        },
        {
            title: `${t("Communication")} & ${t("Schedule")}`,
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <HiOutlinePhoneMissedCall className="vs-icons" />{" "}
                            {t("Emergency_Calls")}
                        </>
                    ),
                    path: "/admin/emergency-calls",
                },
            ],
        },
        {
            title: `${t("Finance")} & ${t("Invoices")}`,
            items: [
                {
                    type: "link",
                    label: (
                        <>
                            <LuEuro className="vs-icons" /> Withdraw
                        </>
                    ),
                    path: "/admin/withdraw",
                },
                {
                    type: "link",
                    label: (
                        <>
                            <LuEuro className="vs-icons" /> {t("Finances")}
                        </>
                    ),
                    path: "/admin/my-finances",
                },

                {
                    type: "link",
                    label: (
                        <>
                            <PiScrollLight className="vs-icons" /> {t("Invoices")}
                        </>
                    ),
                    path: "/admin/invoice",
                },
                {
                    type: "link",
                    label: (
                        <>
                            <PiScrollLight className="vs-icons" /> Commission
                        </>
                    ),
                    path: "/admin/commission",
                },
            ],
        },
        {
            title: `${t("Settings")}`,
            items: [

                // {
                //     type: "dropdown",
                //     title: (
                //         <div className="d-flex justify-content-between align-items-center w-100">
                //             <div>
                //                 <SlSettings className="vs-icons" /> {t("Settings")}
                //             </div>
                //             {isDropdownOpen ? (
                //                 <FaCaretUp className="dd-aricons1" />
                //             ) : (
                //                 <FaCaretDown className="dd-aricons1" />
                //             )}
                //         </div>
                //     ),
                //     options: [
                //         {
                //             label: (
                //                 <>
                //                     <span>{t("Profile")}</span>
                //                     <span>{<FaCaretRight className="dd-aricons" />}</span>
                //                 </>
                //             ),
                //             path: "/admin/my-profile/personal-information",
                //         },
                //         {
                //             label: (
                //                 <>
                //                     <span>{t("Fees")}</span>
                //                     <span>{<FaCaretRight className="dd-aricons" />}</span>
                //                 </>
                //             ),
                //             path: "/admin/my-fees",
                //         },
                //     ],
                // },
                {
                    label: (
                        <>
                            <LuLogOut className="vs-icons" /> {t("Log_Out")}
                        </>
                    ),
                    onClick: () => handleLogout("admin_access"),
                },
            ],
        },
    ];

    let sections;
    if (loginData?.userType === Commons.userType.doctor) {
        sections = docSections;
    } else if (loginData?.userType === Commons.userType.patient) {
        sections = patSections;
    } else if (loginData?.userType === Commons.userType.admin) {
        sections = adminSections;
    }

    return (
        <nav className="leftsides">
            <div className="header-blck">
                <h2 className="exado-title-eight">{t("ExaDo")}</h2>
                <h4 className="exado-title-seven">
                    {t("Hello")} {loginData?.fullName}
                </h4>
                <h6 className="exado_body_text_one" onClick={handaleProfileNavigate}>
                    {t("View_Account")}
                </h6>
            </div>

            <Navvbar.Navvbar1
                sections={sections}
                className="lside-nav-vertically"
                onToggle={handleToggle}
            />
        </nav>
    );
};

export default LeftSides;
